import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import ToolTip from '../../ToolTip/ToolTip';

const BulkActionButton = ({
  action,
  onClick,
  icon,
  disabled,
  iconSize,
}) => (
  <ToolTip
    buttonClassName="focus:outline-none"
    buttonComponentContent={() => (
      <div className={`Bulk ${action} mx-0`}>
        <span className="text-lg flex flex-row">
          <button
            onClick={onClick}
            type="button"
            disabled={disabled}
            className={`${disabled ? 'fill-current opacity-25' : 'fill-current'}`}
            aria-label={`Bulk-Action-${action}-Button`}
          >
            <Icon
              icon={icon}
              size={iconSize}
              className={`${disabled ? 'fill-current opacity-25' : 'fill-current'}`}
            />
          </button>
        </span>
      </div>
    )}
    panelComponentContent={() => (
      <p className="text-white flex items-center justify-center font-bold">
        {action}
      </p>
    )}
    panelClassName="mt-1 bg-grey border mb-2 w-20 p-2 text-white
      border-solid rounded-md shadow-lg leading-normal rounded"
    enableHover
    hoverDelay={0}
    placement="bottom"
    offsetOptions={{ offset: [0, 5] }}
    flipOptions={{ fallbackPlacements: [] }}
  />
);

BulkActionButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  iconSize: PropTypes.number,
};

BulkActionButton.defaultProps = {
  disabled: false,
  iconSize: 25,
};

export default BulkActionButton;
